import React, { useEffect, useState } from "react";
import Axios from "../../../services/AxiosInstance";
import { useNavigate, useSearchParams } from 'react-router-dom';
import Notification from "../../Notification";
import { makeStyles } from '@mui/styles';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#348cd4',
    },
}));
const InsertContactsPayment = () => {
    const Navigate = useNavigate();
    // console.log("enter first");
    const classes = useStyles();
    const [loader, setLoader] = useState({ isOpen: false, isData: '' });
    const [searchParams] = useSearchParams();
    const [notify, setNotify] = useState({ isOpen: false, messsage: '', type: '' })
    const [businessName, setBusinessName] = useState(searchParams.get('business_name'));
    const [businessId, setBusinessId] = useState(searchParams.get('business_id'));
    // const [service, setService] = useState();
    // const [phoneNumber,setPhoneNumber] = useState();
    // const [phoneNumberId, setPhoneNumberId] = useState();
    // const [appType, setAppType] = useState();
    // const [appId, setAppId] = useState();
    // const [wabaId, setWabaId] = useState();
    // const [accessToken, setAccessToken] = useState();
    const [transcationId, setTranscationId] = useState();
    const [recievedAmount, setRecievedAmount] = useState();
    const [allBuyContacts, setAllBuyContacts] = useState([]);
    const [totalAmount, setTotalAmount] = useState();
    const [description, setDescription] = useState();
    const [selectedTotalContacts, setSelectedTotalContacts] = useState();
    const [costPerContacts, setCostPerContacts] = useState();
    const [contactsRangeId, setContactsRangeId] = useState();
    const [transcationDate, setTranscationDate] = useState();
    const [isNowActivate, setIsNowActivate] = useState(false);

    const getsAllPlanInfo = () => {
        Axios.get(`api/admin/get-contacts-buy-list`)
            .then((resp) => {
                // console.log("this is resp", resp);
                // console.log("allPlanDetials", resp.data.data.allPlanDetailsFetch);
                // setBusinessName(searchParams.get('business_name'));
                // setBusinessId(searchParams.get('business_id'));
                setAllBuyContacts(resp.data.data.allContactsDetailsFetch);
                // if (resp.data.data.length !== 0) {
                //     setPhoneNumberId(resp.data.data[0].phone_number_id);
                //     setAppId(resp.data.data[0].app_id);
                //     setWabaId(resp.data.data[0].waba_id);
                //     setAccessToken(resp.data.data[0].access_token);
                // }
            })
            .catch((e) => {
                console.log(e);
            })
    }

    useEffect(() => {
        if (!searchParams.get('request_id')) {
            Navigate('/buy-contacts-request');
        }
        getsAllPlanInfo();
    }, [])


    const selectedBuyContactsFunc = (e) => {
        console.log(e.target.value);
        console.log(allBuyContacts[e.target.value]);
        setSelectedTotalContacts(allBuyContacts[e.target.value].total_contacts);
        setTotalAmount(allBuyContacts[e.target.value].total_amount);
        setCostPerContacts(allBuyContacts[e.target.value].cost_per_contacts);
        setContactsRangeId(allBuyContacts[e.target.value].contacts_range_id);
    }

    const allBuyContactsList = allBuyContacts.map((item, index) => {
        return (
            <option value={index}>{item.total_contacts}</option>
        )
    })

    const submitPaymentCredential = () => {
        console.log(businessName, businessId, selectedTotalContacts, totalAmount, costPerContacts, contactsRangeId, transcationId, recievedAmount, description);
        if(!selectedTotalContacts || !transcationId || !recievedAmount){
            setNotify({
                isOpen: true,
                messsage: "Package Name,Transcation Id and Recieved Amount is required",
                type: 'warning'
            })
            return;
        }

        Axios
            .post("api/admin/insert-contacts-payment-credential", {
                business_name: businessName,
                business_id: businessId,
                total_contacts: selectedTotalContacts,
                total_amount: totalAmount,
                cost_per_contacts: costPerContacts,
                contacts_range_id: contactsRangeId,
                transcation_id: transcationId,
                transcation_date: transcationDate,
                recieved_amount: recievedAmount,
                description: description
            })
            .then((response) => {
                if (response.status == 200) {
                    setIsNowActivate(true);
                }
                setNotify({
                    isOpen: true,
                    messsage: response.data.message,
                    type: 'success'
                })
            }).catch((error) => {
                setNotify({
                    isOpen: true,
                    messsage: "Something Went Wrong",
                    type: 'error'
                })
            });

    }

    const handleActivate = () => {
        console.log(searchParams.get('request_id'));
        Axios.post(`api/admin/activate-buy-contacts?request_id=${searchParams.get('request_id')}`, setLoader({ isOpen: true }))
            .then((res) => {
                console.log(res.data);
                setLoader({ isOpen: false });
                setNotify({
                    isOpen: true,
                    messsage: `${res.data.message}`,
                    type: 'success',
                })
                setTimeout(() => {
                    Navigate('/buy-contacts-request');
                }, 4000)
            })
            .catch((err) => {
                console.log(err);
                setLoader({ isOpen: false });
                setNotify({
                    isOpen: true,
                    messsage: `${err.response.data.message}`,
                    type: 'error'
                })
            })
    }

    return (
        <>
            <div className="content-page">
                <div className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="page-title-box">
                                    <h4 className="page-title">Insert Contacts Payment</h4>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="card-box" style={{ width: "50%", marginTop: "10px" }}>

                                <div className="form-group mb-3">
                                    <label htmlFor="businessName">Business Name</label>
                                    <input
                                        // onChange={(e) => setBusinessName(e.target.value)}
                                        type="text"
                                        id="businessName"
                                        value={businessName}
                                        className="form-control"
                                        placeholder="Enter Business Name"
                                        disabled
                                    />
                                </div>
                                <div className="form-group mb-3">
                                    <label htmlFor="businessId">Business Id</label>
                                    <input
                                        // onChange={(e) => setBusinessId(e.target.value)}
                                        type="text"
                                        id="businessId"
                                        value={businessId}
                                        className="form-control"
                                        placeholder="Enter Business Id"
                                        disabled
                                    />
                                </div>
                                <div className="form-group mb-3">
                                    <label htmlFor="service">Select Number of Contacts Buy</label>
                                    <select
                                        onChange={(e) => { selectedBuyContactsFunc(e) }}
                                        id="package"
                                        type="text"
                                        className="form-control"
                                        // onClick={serviceApi}
                                        style={{
                                            height: "50px", width: "100%"
                                        }}>
                                        <option>Select Total Contacts</option>
                                        {allBuyContactsList}
                                    </select>
                                </div>
                                <div className="form-group mb-3">
                                    <label htmlFor="businessId">Total Amount</label>
                                    <input
                                        // onChange={(e) => setBusinessId(e.target.value)}
                                        type="text"
                                        id="businessId"
                                        value={totalAmount}
                                        className="form-control"
                                        placeholder="N/A"
                                        disabled
                                    />
                                </div>
                                <div className="form-group mb-3">
                                    <label htmlFor="businessId">Cost Per Contacts</label>
                                    <input
                                        // onChange={(e) => setBusinessId(e.target.value)}
                                        type="text"
                                        id="businessId"
                                        value={costPerContacts}
                                        className="form-control"
                                        placeholder="N/A"
                                        disabled
                                    />
                                </div>

                                <div className="form-group mb-3">
                                    <label htmlFor="appId">Transaction Id</label>
                                    <input
                                        onChange={(e) => setTranscationId(e.target.value)}
                                        type="text"
                                        id="transcationId"
                                        value={transcationId}
                                        className="form-control"
                                        placeholder="Enter Transcation Id"
                                    />
                                </div>

                                <div className="form-group mb-3">
                                    <label htmlFor="appId">Transaction Date</label>
                                    <input
                                        type="date"
                                        onChange={(e) => setTranscationDate(e.target.value)}
                                        id="transcationId"
                                        value={transcationDate}
                                        className="form-control"
                                        placeholder="Enter Transcation Id"
                                    />
                                </div>

                                <div className="form-group mb-3">
                                    <label htmlFor="appId">Recieved Amount</label>
                                    <input
                                        onChange={(e) => setRecievedAmount(e.target.value)}
                                        type="number"
                                        id="recievedAmount"
                                        value={recievedAmount}
                                        className="form-control"
                                        placeholder="Enter Recieved Amount"
                                    />
                                </div>

                                <div className="form-group mb-3">
                                    <label htmlFor="accessToken">Brief In Detials (Optional)</label>
                                    <textarea
                                        onChange={(e) => setDescription(e.target.value)}
                                        id="accessToken"
                                        value={description}
                                        className="form-control"
                                        placeholder="Enter Description About Company"
                                        style={{ minHeight: "110px" }}
                                    />
                                </div>
                                <button onClick={submitPaymentCredential} className="btn btn-gradient btn-block" type="submit"> Submit </button>
                                {
                                    notify.isOpen ?
                                        <Notification
                                            notify={notify}
                                            setNotify={setNotify} />
                                        : ""
                                }
                                {isNowActivate ? <button onClick={handleActivate}>Activate</button> : ''}
                            </div>
                        </div>
                    </div>
                </div>
                {loader.isOpen ?
                    <Backdrop className={classes.backdrop} open>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    : ""}
            </div>
        </>
    )
}

export default InsertContactsPayment;